export const maxMinFilters = [
  { value: 'product.name', label: 'Producto' },
];

export const filters = {
  search: true,
};

export const searchInputInitialValues = {
  search: { filter: 'product.name' },
};